const breakpoint = 768;
// 関数定義 **********************************************************************
const fadeInUp = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeInUp');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        y: 20,
        x: 0,
        autoAlpha: 0,
      },
      {
        y: 0,
        x: 0,
        autoAlpha: 1,
        stagger: 0.1,
        duration: 0.8,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        },
      }
    );
  });
};

const fadeInStaggerChildren = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeInStaggerChildren');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(
      target.children,
      {
        y: 20,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: target,
          start: 'top center',
        },
      }
    );
  });
};

const fadeIn = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeIn');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(
      target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        stagger: 0.1,
        duration: 1,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        },
      }
    );
  });
};

// 実行 **********************************************************************
document.addEventListener('DOMContentLoaded', function () {

  fadeInUp();
  fadeIn();
  fadeInStaggerChildren();

});
